import { Box, VStack, Text, Button, Image } from '@chakra-ui/react';
import { ReactElement } from 'react';
import { ExternalRoutes } from 'types/Routes';
import { useBreakpoint } from 'hooks/utils/layout/useBreakpoint';
import { Breakpoints } from 'types/breakpoints';
import accessDenied from 'assets/common/error403.png';

type AccessDeniedProps = {
  title?: string;
  message?: string;
  buttonText?: string;
};

export const AccessDenied = ({
  title = 'Ups! Du hast keinen Zugriff auf diese Seite.',
  message = 'Dieser Bereich ist für dein Konto leider nicht freigegeben. Wenn du denkst, dass das ein Fehler ist, melde dich gern bei uns – wir helfen dir weiter ',
  buttonText = 'Support kontaktieren',
}: AccessDeniedProps): ReactElement => {
  const isDesktop = useBreakpoint(Breakpoints.DESKTOP);
  const buttonWidth = isDesktop ? '40%' : 'full';

  return (
    <VStack
      mt="10%"
      display="flex"
      alignItems="center"
      px="8"
      textAlign="center"
      gap="50px"
      mx="auto"
      pb="40px"
    >
      <Image src={accessDenied} maxHeight="50vh" />
      <Box>
        <Text as="h2" textStyle="h1.medium" color="text.primary">
          {title}
        </Text>
        <Text as="h3" textStyle="h4.regular" color="text.primary" mt="4">
          {message}
        </Text>
      </Box>
      <Button
        variant="primary"
        w={buttonWidth}
        onClick={() => window.open(ExternalRoutes.HELP, '_blank')}
      >
        {buttonText}
      </Button>
    </VStack>
  );
};
